import React from 'react';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import { baseTranslationButtonProps } from '../../../utils/props';
import TranslationButton from '../TranslationButton';
import withTranslationButtonWrapper from '../TranslationButtonWrapper';

const DefaultTranslationButton = ({
    toggled = false,
    loading = false,
    onClick = Function.prototype,
    i18n
}) => {
    const { locale } = getContext();

    const titleSuffix = !toggled || loading ? 'translate_to' : 'show_original';
    const language = i18n.t(`languages.${locale}`);

    return (
        <TranslationButton loading={loading} toggled={toggled} withDisclaimer onClick={onClick}>
            <I18n k={`machine_translation.${titleSuffix}`} params={{ language }}/>
        </TranslationButton>
    );
};

DefaultTranslationButton.propTypes = baseTranslationButtonProps;

export default withTranslationButtonWrapper(DefaultTranslationButton);
